import { render, staticRenderFns } from "./Mahasangram.vue?vue&type=template&id=5cf10333&"
import script from "./Mahasangram.vue?vue&type=script&lang=js&"
export * from "./Mahasangram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports